import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {defineConfig, createSystem, ChakraProvider, defaultBaseConfig, Box} from '@chakra-ui/react3'

import {animationStyles} from './animation-styles'
import {breakpoints} from './breakpoints'
import {globalCss} from './global-css'
import {keyframes} from './keyframes'
import {layerStyles} from './layer-styles'
import {recipes} from './recipes'
import {semanticTokens} from './semantic-tokens'
import {slotRecipes} from './slot-recipes'
import {textStyles} from './text-styles'
import {tokens} from './tokens'

const config = defineConfig({
    cssVarsPrefix: 'leap',
    cssVarsRoot: ':where(html, .chakra-theme)',
    disableLayers: true, // required to allow recipes to work while chakra2 is also used
    preflight: true,
    conditions: {
        light: '.chakra-theme[data-theme=light] &',
        dark: '.chakra-theme[data-theme=dark] &',
        hasLeftIcon: '&:has(> svg:first-child)',
        hasRightIcon: '&:has(> svg:last-child)',
        hasOnlyIcon: '&:has(> svg:only-child)'
    },
    globalCss,
    theme: {
        breakpoints,
        keyframes,
        tokens,
        semanticTokens,
        recipes,
        slotRecipes,
        textStyles,
        layerStyles,
        animationStyles
    }
})

const Chakra3Provider = ({children, theme = 'light'}) => {
    const system = useMemo(() => createSystem(defaultBaseConfig, config), [])
    return (
        <ChakraProvider value={system}>
            <Box className="chakra-theme" data-theme={theme}>
                {children}
            </Box>
        </ChakraProvider>
    )
}

Chakra3Provider.propTypes = {
    children: PropTypes.node,
    theme: PropTypes.oneOf(['light', 'dark'])
}

export default Chakra3Provider
